import { Link } from 'react-router-dom';

const metrics = [
  { value: '一行代码', label: '即可开始统计', icon: 'ri-flashlight-line' },
  { value: 'PV / UV / IP', label: '核心指标齐全', icon: 'ri-global-line' },
  { value: '即装即用', label: '一行代码开始统计', icon: 'ri-shield-check-line' },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden pt-16 md:pt-20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,#E25A3C_0%,transparent_42%),radial-gradient(circle_at_80%_10%,#C4A484_0%,transparent_36%),linear-gradient(160deg,#3b241c_0%,#7a4030_48%,#f3e6d8_100%)]" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50" />

      <div className="relative z-10 w-full px-4 md:px-6 pt-16 pb-24 md:pt-28 md:pb-32">
        <div className="mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 border border-background-50/30 text-background-50 text-sm font-medium backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-accent-400" />
            实时 · 精准 · 轻量级的网站流量统计
          </div>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight">
            一眼看懂你的网站
            <br className="hidden md:block" />
            谁在访问、从哪来
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-100/90 max-w-2xl mx-auto leading-relaxed">
            StatFlow 帮你轻松统计网站访问量、访客数与 IP，实时追踪来源渠道与地域分布。
            贴一行代码，即可拥有专业级的流量分析看板。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/register"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
            >
              免费开始使用
            </Link>
            <a
              href="#dashboard"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 rounded-md transition-colors whitespace-nowrap"
            >
              查看数据看板
            </a>
          </div>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {metrics.map((m) => (
              <div
                key={m.label}
                className="flex items-center gap-3 px-5 py-4 rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/15 text-accent-300">
                  <i className={`${m.icon} text-base`} />
                </span>
                <div className="text-left">
                  <div className="font-heading text-lg font-bold text-background-50">{m.value}</div>
                  <div className="text-xs text-background-100/80">{m.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}